// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"p3-z","dimensionLabel":"q3-z","styleChooserControlWrapper":"r3-z","styleChooserControl":"s3-z","disabled":"t3-z","giftCard":"u3-z","styleChooserText":"v3-z"};